import { render, staticRenderFns } from "./EULADialog.vue?vue&type=template&id=630b10cb&"
import script from "./EULADialog.vue?vue&type=script&lang=ts&"
export * from "./EULADialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports